import type { ModuleNav } from '@saas/ui';

/**
 * workflow のメニュー。管理画面（様式・経路）の権限名は workflow の実装に合わせて後で締める。
 * それまでは owner / admin ロールで守る（PermissionGate も同じ）。
 */
export const WORKFLOW_ADMIN_ROLES = ['owner', 'admin'];

export const workflowNav: ModuleNav = {
  module: 'workflow',
  items: [
    { label: '承認待ち', to: '/workflow/inbox', icon: 'flag', badge: 'workflow.inbox', description: '自分が承認する申請' },
    { label: '申請一覧', to: '/workflow', icon: 'assignment', end: true, description: '稟議・届出の一覧と CSV' },
    { label: '新しい申請', to: '/workflow/new', icon: 'add', description: '様式を選んで作成' },
    { label: '代理承認', to: '/workflow/delegations', icon: 'swap_horiz', description: '不在時の代理を設定' },
    { label: '電子印影', to: '/workflow/stamp', icon: 'shield', description: '承認欄に押される判子' },
    { label: '電子取引データ', to: '/workflow/retention', icon: 'search', description: '日付・金額・取引先で添付を探す' },
  ],
  admin: [
    { label: '申請様式', to: '/workflow/templates', icon: 'description', roles: WORKFLOW_ADMIN_ROLES, permission: ['workflow.template.manage'], description: 'フォームビルダー' },
    { label: '承認経路', to: '/workflow/routes', icon: 'route', roles: WORKFLOW_ADMIN_ROLES, permission: ['workflow.route.manage'], description: '経路の定義とプレビュー' },
  ],
};
